module.exports = require("ace-builds/src-noconflict/ext-language_tools");